import { colonyAPI } from '@/api';
import * as types from './mutation-types';

export default {
  requestWhatsappQRCode({ commit }, channelId) {
    commit(types.REQUEST_WHATSAPP_QRCODE_REQUEST);
    colonyAPI
      .get(`campaigns/channels/whatsapp/qrcode/${channelId}/`)
      .then(response => commit(types.REQUEST_WHATSAPP_QRCODE_SUCCESS, response.data))
      .catch(error => commit(types.REQUEST_WHATSAPP_QRCODE_FAILURE, error));
  },
  createWhatsappChannel({ commit }, handle) {
    commit(types.CREATE_WHATSAPP_CHANNEL_REQUEST);
    colonyAPI
      .post('campaigns/channels/whatsapp/channel/', { handle })
      .then(response => commit(types.CREATE_WHATSAPP_CHANNEL_SUCCESS, response.data))
      .catch(error => commit(types.CREATE_WHATSAPP_CHANNEL_FAILURE, error));
  },
  pollWhatsappStatus({ commit }, channelId) {
    commit(types.POLL_WHATSAPP_SET_CHANNEL, channelId);
    const interval = setInterval(() => {
      colonyAPI
        .get(`campaigns/channels/whatsapp/status/${channelId}/`)
        .then(response => {
          if (
            response.data.is_connected &&
            response.data.is_logged_in &&
            response.data.is_scanned &&
            !response.data.is_unauthorized
          ) {
            commit(types.POLL_WHATSAPP_CHANNEL_SUCCESS);
            commit(types.POLL_WHATSAPP_CHANNEL_STOP);
          }
        })
        .catch(() => commit(types.CREATE_WHATSAPP_CHANNEL_FAILURE));
    }, 2000);

    commit(types.POLL_WHATSAPP_CHANNEL_START, interval);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/whatsapp/actions.js